export const PromotionCampaign = {
    path: '/promotion_campaigns',
    name: 'promotion_campaigns',
    component: () => import('@/views/PromotionCampaign/PromotionCampaignPage.vue'),
    children: [
        {
            path: '/promotion_campaigns/add',
            name: 'promotion_campaigns.add',
            component: () => import('@/views/PromotionCampaign/Form/PromotionCampaignForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/promotion_campaigns/edit/:id',
            name: 'promotion_campaigns.edit',
            component: () => import('@/views/PromotionCampaign/Form/PromotionCampaignForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/promotion_campaigns/delete/:id',
            name: 'promotion_campaigns.delete',
            component: () => import('@/views/PromotionCampaign/Form/PromotionCampaignForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/promotion_campaigns/view/:id',
            name: 'promotion_campaigns.view',
            component: () => import('@/views/PromotionCampaign/Form/PromotionCampaignForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/promotion_campaigns/update_territory/:id',
            name: 'promotion_campaigns.update_territory',
            component: () => import('@/views/PromotionCampaign/Form/UpdateTerritoryForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/promotion_campaigns/view_territory/:id',
            name: 'promotion_campaigns.view_territory',
            component: () => import('@/views/PromotionCampaign/Form/UpdateTerritoryForm.vue'),
            props: {viewAction: true}
        },
    ]
}